import React from "react";
import styled from "styled-components";

const Container = styled.div`
  font-family: Arial, sans-serif;
  line-height: 1.6;
  margin: 0;
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;

  .header {
    text-align: center;
    margin-bottom: 20px;
  }
  .logo {
    max-width: 500px;
    margin-bottom: 10px;
  }
  h1,
  h2,
  h3 {
    color: #333;
  }
  h1 {
    font-size: 32px;
    text-align: center;
    margin-bottom: 5px;
  }
  h2 {
    font-size: 24px;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 30px;
  }
  .subtitle {
    text-align: center;
    font-size: 20px;
    margin-bottom: 40px;
  }
  .stickytitle {
    position: sticky;
    top: 0;
    background-color: #ffebee;
    color: #d32f2f;
    padding: 0px 10px;
    font-weight: bold;
    font-size: 18px;
    z-index: 100;
    height: 30px;
  }
  .stickytitle-start {
    position: sticky;
    top: 0;
    background-color: #e8f5e8;
    color: #2e7d32;
    padding: 0px 10px;
    font-weight: bold;
    font-size: 18px;
    z-index: 100;
    height: 30px;
  }
  .info-section {
    margin-bottom: 15px;
  }
  .info-section strong {
    font-weight: bold;
  }
  .section {
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .section h4 {
    position: sticky;
    top: 30px;
    background-color: #f5f5f5;
    padding: 0 15px;
    z-index: 50;
  }
  .criteria-list {
    list-style-type: decimal;
    padding-left: 40px;
  }
  .criteria-list li {
    margin-bottom: 15px;
  }
  .footer {
    text-align: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #ddd;
  }
  .pdf-link {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0;
  }
  .pdf-link img {
    height: 40px;
    margin-right: 10px;
  }
  .toolkit-footer {
    text-align: center;
    margin-top: 40px;
  }
  .page-break {
    page-break-before: always;
    margin-top: 50px;
  }
  a {
    color: #0066cc;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`;

const SPSTv3: React.FC = () => {
  return (
    <Container>
      <div className="cover">
        <div className="header">
          <h1>
            CGA Toolkit <span style={{ color: "#cc0000" }}>Plus</span>
          </h1>
          <p className="website">www.cgakit.com</p>
          <p className="subtitle">
            Resources for the Comprehensive Geriatric Assessment based
            <br /> Proactive and Personalised Primary Care of the Elderly
          </p>
        </div>

        <h1>STOPP-START v.3</h1>
        <h2>
          Screening Tool Of Older People's Prescriptions (STOPP)
          <br />
          Screening Tool to Alert to Right Treatment (START)
        </h2>

        <div className="info-section">
          <p>
            <strong>Purpose : </strong>STOPP/START is a physiological systems-based explicit set of
            criteria that attempts to define the clinically important prescribing problems relating
            to potentially inappropriate medications (PIMs–STOPP criteria) and potential prescribing
            omissions (PPOs–START criteria). The previous two versions of STOPP/START criteria were
            published in 2008 and 2015. The 2023 version is the revised and updated third version of
            the criteria.
          </p>
        </div>

        <div className="info-section">
          <p>
            <strong>Admin time : </strong>Highly operator dependent - 5 mins for an expert, up to
            20-30 mins
          </p>
        </div>

        <div className="info-section">
          <p>
            <strong>User Friendly : </strong>Moderate
          </p>
        </div>

        <div className="info-section">
          <p>
            <strong>Administered by : </strong>GP, Physician, Community Pharmacist
          </p>
        </div>

        <div className="info-section">
          <p>
            <strong>Content : </strong>Explicit criteria that facilitate medication review in
            multi-morbid older people in most clinical settings.
          </p>
        </div>

        <div className="info-section">
          <p>
            <strong>Author : </strong>O'Mahony D et al, 31 May 2023
            <br />
            correction O'Mahony D et al,16 June 2023
          </p>
        </div>

        <div className="info-section">
          <p>
            <strong>Copyright : </strong>Open Access
          </p>
        </div>

        <div className="info-section">
          <p>
            The source articleis licensed under a Creative Commons Attribution 4.0 International
            License, which permits use, sharing, adaptation, distribution and reproduction in any
            medium or format, as long as you give appropriate credit to the original author(s) and
            the source, provide a link to the Creative Commons licence, and indicate if changes were
            made. The images or other third party material in this article are included in the
            article's Creative Commons licence, unless indicated otherwise in a credit line to the
            material. If material is not included in the article's Creative Commons licence and your
            intended use is not permitted by statutory regulation or exceeds the permitted use, you
            will need to obtain permission directly from the copyright holder. To view a copy of
            this licence, visit{" "}
            <a href="http://creativecommons.org/licenses/by/4.0/">
              http://creativecommons.org/licenses/by/4.0/
            </a>
            .
          </p>
        </div>

        <div className="toolkit-footer">
          <h3>
            CGA Toolkit <span style={{ color: "#cc0000" }}>Plus</span>
          </h3>
          <p>www.cgakit.com</p>
        </div>
      </div>

      <div className="page-break">
        <div className="page-divider"></div>
      </div>

      <div className="title" style={{ textAlign: "center" }}>
        <h1>STOPP</h1>
        <h2 id="STOP_desc_001" style={{ marginBottom: "0px" }}>Screening Tool Of Older People's Prescriptions</h2>
        <p id="STOP_desc_002" style={{ fontWeight: "bold", marginTop: "0px" }}>
          The following prescriptions are potentially inappropriate to use in patients aged 65 years
          and older.
        </p>
      </div>

      <div className="stickytitle">STOP</div>
      
      <div className="section">
        <h4 id="STOP_DIND_003">Section A: Indication of medication</h4>
        <ol className="criteria-list">
          <li id="STOP_DIND_004">Any drug prescribed without a clinical indication.</li>
          <li id="STOP_DIND_005">
            Any drug prescribed beyond the recommended duration, where treatment duration is well
            defined.
          </li>
          <li id="STOP_DIND_006">
            Any duplicate drug class prescription for daily regular use (as distinct from PRN use)
            e.g., two concurrent NSAIDs, SSRIs, loop diuretics, ACE inhibitors, anticoagulants,
            antipsychotics, opioid analgesics (optimisation of monotherapy within a single drug
            class should be observed prior to considering a new agent).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="STOP_CVD_007">Section B: Cardiovascular System</h4>
        <ol className="criteria-list">
          <li id="STOP_CVD_008">
            Digoxin for heart failure with normal systolic ventricular function (no clear evidence
            of benefit)
          </li>
          <li id="STOP_CVD_009">
            Verapamil or diltiazem with NYHA Class III or IV heart failure (may worsen heart failure
            with reduced ejection fraction i.e., HFREF).
          </li>
          <li id="STOP_CVD_010">
            Beta-blocker in combination with verapamil or diltiazem (risk of heart block).
          </li>
          <li id="STOP_CVD_011">
            Ventricular rate-limiting drugs i.e., beta blocker, verapamil, diltiazem, digoxin with
            bradycardia (&lt; 50/min), type II heart block or complete heart block (risk of complete
            heart block, asystole).
          </li>
          <li id="STOP_CVD_012">
            Beta-blocker as monotherapy for uncomplicated hypertension i.e., not associated with
            angina pectoris, aortic aneurysm or other condition where beta-blocker therapy is
            indicated (no firm evidence of efficacy).
          </li>
          <li id="STOP_CVD_013">
            Amiodarone as first-line antiarrhythmic therapy in supraventricular tachyarrhythmias
            (higher risk of major side-effects than beta-blockers, digoxin, verapamil or diltiazem).
          </li>
          <li id="STOP_CVD_014">
            Loop diuretic as first-line treatment for hypertension unless there is concurrent heart
            failure requiring diuretic therapy (safer, more effective alternatives available).
          </li>
          <li id="STOP_CVD_015">
            Loop diuretic for dependent ankle oedema without clinical, biochemical or radiological
            evidence of heart failure, liver failure, nephrotic syndrome or renal failure (leg
            elevation and /or compression hosiery usually more appropriate).
          </li>
          <li id="STOP_CVD_016">
            Thiazide diuretic with current significant hypokalaemia (i.e., serum K+ &lt; 3.0
            mmol/l), hyponatraemia (i.e., serum Na+ &lt; 130 mmol/l) hypercalcaemia (i.e., corrected
            serum calcium &gt; 2.65 mmol/l) or with a history of gout (hypokalaemia, hyponatraemia,
            hypercalcaemia and gout can be precipitated by thiazide diuretic)
          </li>
          <li id="STOP_CVD_017">
            Loop diuretic for treatment of hypertension with concurrent urinary incontinence (may
            exacerbate incontinence).
          </li>
          <li id="STOP_CVD_018">
            Centrally-acting antihypertensives e.g., methyldopa, clonidine, moxonidine, rilmenidine,
            guanfacine (centrally-active antihypertensives are generally less well tolerated by
            older people than younger people)
          </li>
          <li id="STOP_CVD_019">
            Angiotensin-Converting Enzyme inhibitors (ACEIs) or Angiotensin Receptor Blockers (ARBs)
            in patients with hyperkalaemia i.e., serum K &gt; 5.5 mmol/l.
          </li>
          <li id="STOP_CVD_020">
            Aldosterone antagonists (e.g., spironolactone, eplerenone) with concurrent potassium-
            conserving drugs (e.g., ACEI's, ARB's, amiloride, triamterene) without monitoring of
            serum potassium (risk of dangerous hyperkalaemia i.e., &gt; 6.0 mmol/l – serum K should
            be monitored regularly, i.e., at least every 6 months).
          </li>
          <li id="STOP_CVD_021">
            Phosphodiesterase type-5 inhibitors (e.g., sildenafil, tadalafil, vardenafil) in severe
            heart failure characterised by hypotension i.e., systolic BP &lt; 90 mmHg, or concurrent
            nitrate therapy for angina (risk of cardiovascular collapse).
          </li>
          <li id="STOP_CVD_022">
            Drugs that predictably prolong the QTc interval (QTc = QT/RR) in patients with known
            with demonstrable QTc prolongation (to &gt;450 msec in males and &gt;470 msec in
            females), including quinolones, macrolides, ondansetron, citalopram (doses &gt; 20
            mg/day), escitalopram (doses &gt; 10 mg/day), tricyclic antidepressants, lithium,
            haloperidol, digoxin, class 1A antiarrhythmics, class III antiarrhythmics, tizanidine,
            phenothiazines, astemizole, mirabegron (risk of life- threatening ventricular
            arrhythmias).
          </li>
          <li id="STOP_CVD_023">
            Statins for primary cardiovascular prevention in persons aged ≥ 85 and established
            frailty with expected life expectancy likely less than 3 years (lack of evidence of
            efficacy).
          </li>
          <li id="STOP_CVD_024">
            Long-term systemic i.e., non-topical NSAIDs with known history of coronary, cerebral or
            peripheral vascular disease (increased risk of thrombosis).
          </li>
          <li id="STOP_CVD_025">
            Long-term antipsychotics with known history of coronary, cerebral or peripheral vascular
            disease (increased risk of thrombosis).
          </li>
          <li id="STOP_CVD_026">
            NSAIDs or systemic corticosteroids with heart failure requiring loop diuretic therapy
            (risk of exacerbation of heart failure).
          </li>
          <li id="STOP_CVD_027">
            Antihypertensive drugs in severe symptomatic aortic stenosis (risk of severe
            hypotension, syncope).
          </li>
          <li id="STOP_CVD_028">
            Digoxin as first line treatment for long-term (&gt; 3 months) ventricular rate control
            in atrial fibrillation (increased mortality from long-term digoxin use; cardio-selective
            beta-blockers are generally preferable).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="STOP_COAG_029">Section C: Coagulation System</h4>
        <ol className="criteria-list">
          <li id="STOP_COAG_030">
            Long-term aspirin at doses greater than 100mg per day (increased risk of bleeding, no
            evidence for increased efficacy).
          </li>
          <li id="STOP_COAG_031">
            Antiplatelet agents, vitamin K antagonists, direct thrombin inhibitors or factor Xa
            inhibitors with concurrent significant risk of major bleeding, i.e. uncontrolled severe
            hypertension, bleeding diathesis, recent non-trivial spontaneous bleeding (high risk of
            bleeding).
          </li>
          <li id="STOP_COAG_032">
            Aspirin plus clopidogrel as long-term secondary stroke prevention i.e., &gt; 4 weeks,
            unless the patient has a coronary stent(s) inserted in the previous 12 months or
            concurrent acute coronary syndrome or has a high grade symptomatic carotid arterial
            stenosis (no evidence of added long-term benefit over clopidogrel monotherapy).
          </li>
          <li id="STOP_COAG_033">
            Antiplatelet agents in combination with vitamin K antagonist, direct thrombin inhibitor
            or factor Xa inhibitors in patients with chronic atrial fibrillation, unless there is
            concurrent coronary artery stent(s) inserted or angiographically proven high grade (&gt;
            50%) coronary artery stenosis (no added benefit from antiplatelet agents).
          </li>
          <li id="STOP_COAG_034">
            Antiplatelet agents with vitamin K antagonist, direct thrombin inhibitor or factor Xa
            inhibitors in patients with stable coronary, cerebrovascular or peripheral arterial
            disease (no evidence of added benefit from dual therapy).
          </li>
          <li id="STOP_COAG_035">
            Ticlopidine in any circumstances (clopidogrel and prasugrel have similar efficacy,
            stronger evidence and fewer side-effects).
          </li>
          <li id="STOP_COAG_036">
            Antiplatelet agents as alternatives to vitamin K antagonists, direct thrombin inhibitors
            or factor Xa inhibitors for stroke prevention in patients with chronic atrial
            fibrillation (no evidence of efficacy).
          </li>
          <li id="STOP_COAG_037">
            Vitamin K antagonist, direct thrombin inhibitor or factor Xa inhibitors for first deep
            venous thrombosis without continuing provoking risk factors (e.g., thrombophilia) for
            longer than 6 months, (no proven added benefit).
          </li>
          <li id="STOP_COAG_038">
            Vitamin K antagonist, direct thrombin inhibitor or factor Xa inhibitors for first
            pulmonary embolus without continuing provoking risk factors (e.g., thrombophilia) for
            longer than 12 months (no proven added benefit).
          </li>
          <li id="STOP_COAG_039">
            Nonsteroidal anti-inflammatory drugs (NSAIDs) and vitamin K antagonist, direct thrombin
            inhibitor or factor Xa inhibitors in combination (risk of major gastrointestinal
            bleeding).
          </li>
          <li id="STOP_COAG_040">
            Vitamin K antagonist as first-line anticoagulant for atrial fibrillation, unless there
            is concurrent metallic heart valve in-situ, moderate-to-severe mitral stenosis, or eGFR
            &lt; 15 mls/min./1.73m2 (direct thrombin inhibitors or factor Xa inhibitors are equally
            efficacious and safer than vitamin K antagonists).
          </li>
          <li id="STOP_COAG_041">
            Selective serotonin reuptake inhibitors (SSRIs) in combination with Vitamin K
            antagonist, direct thrombin inhibitor or factor Xa inhibitor with a previous history of
            major haemorrhage (increased risk of bleeding due to antiplatelet effects of SSRIs).
          </li>
          <li id="STOP_COAG_042">
            Direct thrombin inhibitor (e.g., dabigatran) and diltiazem or verapamil (increased risk
            of bleeding).
          </li>
          <li id="STOP_COAG_043">
            Apixaban, dabigatran, edoxaban, rivaroxaban and P-glycoprotein (P-gp) drug efflux pump
            inhibitors e.g., amiodarone, azithromycin, carvedilol, cyclosporin, dronedarone,
            itraconazole, ketoconazole (systemic), macrolides, quinine, ranolazine, tamoxifen,
            ticagrelor, verapamil (increased risk of bleeding).
          </li>
          <li id="STOP_COAG_044">
            Systemic oestrogens or androgens with pervious history of venous thromboembolism
            (increased risk of recurrent venous thromboembolism).
          </li>
          <li id="STOP_COAG_045">
            Aspirin for primary prevention in cardiovascular disease (no evidence of benefit).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="STOP_CNS_046">Section D: Central Nervous System</h4>
        <ol className="criteria-list">
          <li id="STOP_CNS_047">
            TriCyclic Antidepressants (TCAs) in patients with dementia, narrow angle glaucoma,
            cardiac conduction abnormalities, prostatism, chronic constipation, recent falls, prior
            history of urinary retention or orthostatic hypotension (risk of worsening these
            conditions).
          </li>
          <li id="STOP_CNS_048">
            Initiation of TriCyclic Antidepressants (TCAs) as first-line treatment for major
            depression (higher risk of adverse drug reactions with TCAs than with SSRIs or SNRIs).
          </li>
          <li id="STOP_CNS_049">
            Serotonin/noradrenaline reuptake inhibitors (SNRI's e.g., venlafaxine, duloxetine) and
            severe hypertension i.e., systolic blood pressure &gt; 180 mmHg +/- diastolic blood
            pressure &gt; 105 mmHg (likely to make hypertension worse).
          </li>
          <li id="STOP_CNS_050">
            Antipsychotics with moderate-marked antimuscarinic/anticholinergic effects
            (acepromazine, chlorpromazine, clozapine, flupenthixol, fluphenzine, levomepromazine,
            olanzapine, pipothiazine, promazine, thioridazine) with a history of lower urinary tract
            symptoms associated with benign prostatic hyperplasia or previous urinary retention
            (high risk of urinary retention).
          </li>
          <li id="STOP_CNS_051">
            Antipsychotics prescribed for behavioural and psychological symptoms of dementia (BPSD)
            an unchanged dose for &gt; 3 months without medication review (increased risk of
            extrapyramidal side-effects and chronic worsening of cognition, increased risk of major
            cardiovascular morbidity and mortality).
          </li>
          <li id="STOP_CNS_052">
            Selective serotonin re-uptake inhibitors (SSRI's) with current or recent significant
            hyponatraemia i.e., serum Na+ &lt; 130 mmol/l (risk of exacerbating or precipitating
            hyponatraemia).
          </li>
          <li id="STOP_CNS_053">
            Selective serotonin re-uptake inhibitors (SSRI's) with current or recent significant
            bleeding (risk of exacerbation or recurrence of bleeding due to antiplatelet effects of
            SSRI's).
          </li>
          <li id="STOP_CNS_054">
            Benzodiazepines for ≥ 4 weeks (no indication for longer treatment; risk of prolonged
            sedation, confusion, impaired balance, falls, road traffic accidents; all
            benzodiazepines should be withdrawn gradually if taken for more than 4 weeks as there is
            a risk of causing a benzodiazepine withdrawal syndrome if stopped abruptly).
          </li>
          <li id="STOP_CNS_055">
            Benzodiazepines for agitated behaviour or psychotic symptoms of dementia (no evidence of
            efficacy).
          </li>
          <li id="STOP_CNS_056">
            Benzodiazepines for insomnia for ≥ 2 weeks (high risk of dependency, increased risk of
            falls, fractures and road traffic accidents).
          </li>
          <li id="STOP_CNS_057">
            Z-drugs (zolpidem, zopiclone, zaleplon) for insomnia for ≥ 2 weeks (increased risk of
            falls, fractures).
          </li>
          <li id="STOP_CNS_058">
            Antipsychotics (i.e., other than clozapine or quetiapine) in those with parkinsonism or
            Dementia with Lewy Bodies (risk of severe extra-pyramidal symptoms).
          </li>
          <li id="STOP_CNS_059">
            Anticholinergic/antimuscarinic drugs (biperiden, orphenadrine, procyclidine,
            trihexyphenidyl) to treat extra-pyramidal side-effects of antipsychotic medications
            (risk of anticholinergic toxicity).
          </li>
          <li id="STOP_CNS_060">
            Drugs with potent anticholinergics/antimuscarinic effects** in patients with delirium or
            dementia (risk of exacerbation of cognitive impairment).
          </li>
          <div
            className="criteria-comment"
            style={{ margin: "10px 0 10px 0", fontSize: "0.98em", color: "#222" }}
          >
            <strong>**</strong> Commonly prescribed drugs with potent anticholinergic/
            antimuscarinic effects include tricyclic antidepressants (e.g., amitriptyline, doxepin,
            impramine, nortriptyline), antipsychotics (chlorpromazine, clozapine, thioridazine),
            first generation antihistamines (e.g., diphenhydramine, chlorpheniramine), bladder
            anti-spasmodics (e.g., tolterodine, oxybutynin), hyoscine, procyclidine, benzatropine,
            tizanidine.
          </div>
          <li id="STOP_CNS_061">
            Antipsychotics in patients with behavioural and psychological symptoms of dementia
            (BPSD) for longer than 12 weeks unless BPSD symptoms are severe and other non-
            pharmacological treatments have failed (increased risk of stroke, myocardial
            infarction).
          </li>
          <li id="STOP_CNS_062">
            Antipsychotics as hypnotics, unless sleep disorder is due to psychosis or BPSD effects
            of dementia (not recommended in summary of product characteristics; increased risk of
            confusion, hypotension, extra-pyramidal side effects, falls).
          </li>
          <li id="STOP_CNS_063">
            Acetylcholinesterase inhibitors with a known history of persistent bradycardia (&lt; 60
            beats/min.), heart block or recurrent unexplained syncope (risk of cardiac conduction
            failure, syncope and injury).
          </li>
          <li id="STOP_CNS_064">
            Acetylcholinesterase inhibitors with concurrent treatment with drugs that induce
            persistent bradycardia (&lt; 60 beats/min.) such as beta-blockers, digoxin, diltiazem,
            verapamil (risk of cardiac conduction failure, syncope and injury).
          </li>
          <li id="STOP_CNS_065">
            Memantine with known current or previous seizure disorder (increased risk of seizures).
          </li>
          <li id="STOP_CNS_066">
            Nootropics in dementia including Gingko Biloba, piracetam, pramiracetam,
            phenylpiracetam, aniracetam, phosphatidylserine, modafinil, L-theanine, omega-3 fatty
            acids, panax ginseng, rhodiola, creatine (no evidence of efficacy).
          </li>
          <li id="STOP_CNS_067">
            Phenothiazines as first-line treatment for psychosis or non-cognitive symptoms of
            dementia, since safer and more efficacious alternatives exist (phenothiazines are
            sedative, have significant anti-muscarinic toxicity in older people, except for
            prochlorperazine for nausea/vomiting/vertigo, chlorpromazine for relief of persistent
            hiccoughs and levomepromazine as an anti-emetic in palliative care).
          </li>
          <li id="STOP_CNS_068">
            Levodopa or dopamine agonists for benign essential tremor (no evidence of efficacy)
          </li>
          <li id="STOP_CNS_069">
            Levodopa or dopamine agonists for treatment of extrapyramidal side-effects of
            antipsychotics or other forms of drug-induced Parkinsonism (inappropriate prescribing
            cascade to be avoided).
          </li>
          <li id="STOP_CNS_070">
            First-generation antihistamines as first-line treatment for allergy or pruritus (safer
            antihistamines with fewer side-effects now widely available).
          </li>
          <li id="STOP_CNS_071">
            First-generation antihistamines for insomnia (high risk of side-effects, Z-drugs safer
            and more appropriate for short-term use).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="STOP_KDNY_072">Section E: Renal System</h4>
        <ol className="criteria-list">
          <li id="STOP_KDNY_073">
            Digoxin at a long-term (i.e. more than 90 days) maintenance dose ≥ 125µg/day if eGFR
            &lt; 30 ml/min/1.73m2 (risk of digoxin toxicity if plasma levels not measured).
          </li>
          <li id="STOP_KDNY_074">
            Direct thrombin inhibitors (e.g., dabigatran) if eGFR &lt; 30 ml/min/1.73m2 (risk of
            bleeding)
          </li>
          <li id="STOP_KDNY_075">
            Factor Xa inhibitors (e.g., rivaroxaban, apixaban, edoxaban) if eGFR &lt; 15
            ml/min/1.73m2 (risk of bleeding)
          </li>
          <li id="STOP_KDNY_076">
            NSAID's if eGFR &lt; 50 ml/min/1.73m2 (risk of deterioration in renal function).
          </li>
          <li id="STOP_KDNY_077">
            Colchicine if eGFR &lt; 10 ml/min/1.73m2 (risk of colchicine toxicity)
          </li>
          <li id="STOP_KDNY_078">
            Metformin if eGFR &lt; 30 ml/min/1.73m2 (risk of lactic acidosis).
          </li>
          <li id="STOP_KDNY_079">
            Mineralocorticoid receptor antagonists (e.g. spironolactone, eplerenone) if eGFR &lt; 30
            ml/min/1.73m2 (risk of dangerous hyperkalaemia).
          </li>
          <li id="STOP_KDNY_080">
            Nitrofurantoin if eGFR &lt; 45 ml/min/1.73m2 (increased risk of nitrofurantoin
            toxicity).
          </li>
          <li id="STOP_KDNY_081">
            Bisphosphonates if eGFR &lt; 30 ml/min/1.73m2 (increased risk of acute renal failure).
          </li>
          <li id="STOP_KDNY_082">
            Methotrexate if eGFR &lt; 30 ml/min/1.73m2 (increased risk of methotrexate toxicity).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="STOP_GI_083">Section F: Gastrointestinal System</h4>
        <ol className="criteria-list">
          <li id="STOP_GI_084">
            Prochlorperazine or metoclopramide with Parkinsonism (risk of exacerbating Parkinsonian
            symptoms).
          </li>
          <li id="STOP_GI_085">
            Proton pump inhibitor (PPI) for uncomplicated peptic ulcer disease at full therapeutic
            dosage for &gt; 8 weeks (dose reduction or earlier discontinuation or H2 antagonist
            maintenance therapy usually indicated).
          </li>
          <li id="STOP_GI_086">
            Drugs likely to cause constipation (e.g. systemic antimuscarinics, oral iron, opioids,
            verapamil, aluminium antacids) with chronic constipation where non-constipating
            alternatives are available (risk of exacerbation of constipation).
          </li>
          <li id="STOP_GI_087">
            Oral elemental iron doses greater than 200 mg daily (e.g. ferrous fumarate &gt; 600
            mg/day, ferrous sulphate &gt; 600 mg/day, ferrous gluconate &gt; 1800 mg/day; no
            evidence of enhanced iron absorption above these doses).
          </li>
          <li id="STOP_GI_088">
            Corticosteroids with a history of peptic ulcer disease or erosive oesophagitis (risk of
            relapse unless proton pump inhibitor is co-prescribed).
          </li>
          <li id="STOP_GI_089">
            Antiplatelet or anticoagulant drugs with a history of Gastric Antral Vascular Ectasia
            (GAVE, "watermelon stomach") (risk of major gastrointestinal bleeding).
          </li>
          <li id="STOP_GI_090">
            Antipsychotics with dysphagia (increased risk of aspiration pneumonia).
          </li>
          <li id="STOP_GI_091">
            Megestrol acetate to increase appetite (increased risk of thrombosis and death with
            unproven efficacy)
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="STOP_RESP_092">Section G: Respiratory System</h4>
        <ol className="criteria-list">
          <li id="STOP_RESP_093">
            Theophylline as monotherapy for COPD (safer, more effective alternative; risk of adverse
            effects due to narrow therapeutic index).
          </li>
          <li id="STOP_RESP_094">
            Systemic corticosteroids instead of inhaled corticosteroids for maintenance therapy in
            moderate-severe COPD (unnecessary exposure to long-term side-effects of systemic
            corticosteroids and effective inhaled therapies are available).
          </li>
          <li id="STOP_RESP_095">
            Long-acting muscarinic antagonists (e.g., tiotropium, aclidinium, umeclidinium,
            glycopyrronium) with a history of narrow angle glaucoma (may exacerbate glaucoma) or
            bladder outflow obstruction (may cause urinary retention).
          </li>
          <li id="STOP_RESP_096">
            Benzodiazepines with acute or chronic respiratory failure i.e. pO2 &lt; 8.0 kPa ± pCO2
            &gt; 6.5 kPa (risk of exacerbation of respiratory failure).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="STOP_ORTHO_097">Section H: Musculoskeletal System</h4>
        <ol className="criteria-list">
          <li id="STOP_ORTHO_098">
            Non-steroidal anti-inflammatory drugs (NSAIDs) other than COX-2 selective agents with
            history of peptic ulcer disease or gastrointestinal bleeding, unless with concurrent PPI
            or H2 antagonist (risk of peptic ulcer relapse).
          </li>
          <li id="STOP_ORTHO_099">
            NSAID's with severe hypertension i.e., systolic blood pressure consistently above 170
            mmHg and/or diastolic blood pressure consistently above 100 mmHg (risk of exacerbation
            of hypertension).
          </li>
          <li id="STOP_ORTHO_100">
            Long-term use of NSAID (&gt;3 months) for symptom relief of osteoarthritis pain where
            paracetamol has not been tried (simple analgesics preferable and usually as effective
            for pain relief and safer).
          </li>
          <li id="STOP_ORTHO_101">
            Long-term corticosteroids (&gt;3 months) as monotherapy for rheumatoid arthritis (risk
            of systemic corticosteroid side-effects).
          </li>
          <li id="STOP_ORTHO_102">
            Corticosteroids (other than periodic intra-articular injections for mono-articular pain)
            for osteoarthritis (risk of systemic corticosteroid side-effects).
          </li>
          <li id="STOP_ORTHO_103">
            Long-term NSAID or colchicine (&gt;3 months) for chronic treatment of gout where there
            is no contraindication to a xanthine-oxidase inhibitor (e.g., allopurinol, febuxostat)
            (xanthine- oxidase inhibitors are first choice prophylactic drugs in gout).
          </li>
          <li id="STOP_ORTHO_104">
            NSAID with concurrent corticosteroids for treatment of arthritis/rheumatism of any kind
            (increased risk of peptic ulcer disease).
          </li>
          <li id="STOP_ORTHO_105">
            Oral bisphosphonates in patients with a current or recent history of upper
            gastrointestinal disease i.e. dysphagia, oesophagitis, gastritis, duodenitis, or peptic
            ulcer disease, or upper gastrointestinal bleeding (risk of relapse/exacerbation of
            oesophagitis, oesophageal ulcer, oesophageal stricture).
          </li>
          <li id="STOP_ORTHO_106">
            Long-term opioids for osteoarthritis (lack of evidence of efficacy, increased risk of
            serious side-effects).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="STOP_GU_107">Section I: Urogenital System</h4>
        <ol className="criteria-list">
          <li id="STOP_GU_108">
            Systemic antimuscarinic drugs (e.g., oxybutynin, tolterodine, trospium) with dementia or
            chronic cognitive impairment (risk of increased confusion, agitation).
          </li>
          <li id="STOP_GU_109">
            Systemic antimuscarinic drugs (e.g., oxybutynin, tolterodine, trospium) with
            narrow-angle glaucoma (risk of acute exacerbation of glaucoma).
          </li>
          <li id="STOP_GU_110">
            Systemic antimuscarinic (e.g., oxybutynin, tolterodine, trospium) drugs for lower
            urinary tract symptoms with benign prostatic hyperplasia (BPH) and high post-void
            residual volume i.e. &gt; 200 ml (uncertain efficacy and increased risk of urinary
            retention in older men).
          </li>
          <li id="STOP_GU_111">
            Systemic antimuscarinic drugs (e.g., oxybutynin, tolterodine, trospium) with
            constipation (risk of exacerbation of constipation).
          </li>
          <li id="STOP_GU_112">
            Alpha-1 receptor antagonists other than silodosin (e.g., alfuzosin, doxazosin,
            indoramin, tamsulosin, terazosin) with symptomatic orthostatic hypotension or history of
            syncope (risk of precipitating recurrent syncope).
          </li>
          <li id="STOP_GU_113">
            Mirabegron in labile or severe hypertension (risk of exacerbation of hypertension).
          </li>
          <li id="STOP_GU_114">
            Duloxetine with urinary urgency or urge incontinence (duloxetine is indicated in stress
            incontinence but not in urinary urgency or urge incontinence).
          </li>
          <li id="STOP_GU_115">
            Antibiotic use in asymptomatic bacteriuria (no indication for treatment).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="STOP_ENDO_116">Section J: Endocrine System</h4>
        <ol className="criteria-list">
          <li id="STOP_ENDO_117">
            Sulphonylureas with a long half-life (e.g., glibenclamide, chlorpropamide, glimepiride)
            with type 2 diabetes mellitus (risk of prolonged hypoglycaemia).
          </li>
          <li id="STOP_ENDO_118">
            Thiazolidenediones (e.g., rosiglitazone, pioglitazone) with heart failure (risk of
            exacerbation of heart failure).
          </li>
          <li id="STOP_ENDO_119">
            Non-selective beta-blockers in diabetes mellitus with frequent hypoglycaemic episodes
            (risk of suppressing hypoglycaemic symptoms).
          </li>
          <li id="STOP_ENDO_120">
            Sodium glucose co-transporter (SGLT2) inhibitors (e.g., canagliflozin, dapagliflozin,
            empagliflozin, ertugliflozin) with symptomatic hypotension (risk of exacerbation of
            hypotension).
          </li>
          <li id="STOP_ENDO_121">
            Systemic oestrogens with a history of breast cancer (increased risk of recurrence).
          </li>
          <li id="STOP_ENDO_122">
            Systemic oestrogens with a history of venous thromboembolism (increased risk of
            recurrence).
          </li>
          <li id="STOP_ENDO_123">
            Menopausal hormone therapy (oestrogen plus progestin) with a history of stenotic
            coronary, cerebral or peripheral arterial disease (increased risk of acute arterial
            thrombosis).
          </li>
          <li id="STOP_ENDO_124">
            Systemic oestrogens without progestogens in patients with intact uterus (risk of
            endometrial cancer).
          </li>
          <li id="STOP_ENDO_125">
            Levothyroxine in subclinical hypothyroidism i.e., normal free T4, elevated TSH but &lt;
            10 mU/L (no evidence of benefit, risk of iatrogenic thyrotoxicosis).
          </li>
          <li id="STOP_ENDO_126">
            Vasopressin analogues (e.g., desmopressin, vasopressin) for urinary incontinence or
            urinary frequency (risk of symptomatic hyponatraemia).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="STOP_FALL_127">
          Section K: Drug classes that predictably increase falls risk in susceptible older people
        </h4>
        <ol className="criteria-list">
          <li id="STOP_FALL_128">
            Benzodiazepines in patients with recurrent falls (may cause reduced sensorium, impair
            balance).
          </li>
          <li id="STOP_FALL_129">
            Antipsychotic drugs in patients with recurrent falls (may cause Parkinsonism).
          </li>
          <li id="STOP_FALL_130">
            Vasodilator drugs in patients with recurrent falls with persistent postural hypotension
            i.e., systolic BP drop ≥ 20 mmHg and/or diastolic BP drop ≥ 10 mmHg (risk of syncope,
            falls).
          </li>
          <li id="STOP_FALL_131">
            Hypnotic Z-drugs i.e., zopiclone, zolpidem, zaleplon in patients with recurrent falls
            (may cause protracted daytime sedation, ataxia).
          </li>
          <li id="STOP_FALL_132">
            Anti-epileptic drugs in patients with recurrent falls (may impair sensorium, may
            adversely affect cerebellar function).
          </li>
          <li id="STOP_FALL_133">
            First generation antihistamines in patients with recurrent falls (may impair sensorium).
          </li>
          <li id="STOP_FALL_134">
            Opioids in patients with recurrent falls (may impair sensorium).
          </li>
          <li id="STOP_FALL_135">
            Antidepressants in patients with recurrent falls (may impair sensorium).
          </li>
          <li id="STOP_FALL_136">
            Alpha blockers as antihypertensives in patients with recurrent falls (may cause
            orthostatic hypotension).
          </li>
          <li id="STOP_FALL_137">
            Alpha blockers for prostatic bladder outflow symptoms, other than silodosin in patients
            with recurrent falls (may cause orthostatic hypotension).
          </li>
          <li id="STOP_FALL_138">
            Centrally acting antihypertensives (may impair sensorium and may cause orthostatic
            hypotension).
          </li>
          <li id="STOP_FALL_139">
            Antimuscarinics for treatment of overactive bladder or urge incontinence (may impair
            sensorium).
          </li>
        </ol>
      </div>
      <div className="section">
        <h4 id="STOP_PAIN_140">Section L: Analgesic Drugs</h4>
        <ol className="criteria-list">
          <li id="STOP_PAIN_141">
            Use of oral or transdermal strong opioids (morphine, oxycodone, fentanyl, buprenorphine,
            diamorphine, methadone, tramadol, pethidine, pentazocine) as first line therapy for mild
            pain (WHO analgesic ladder not observed; paracetamol or NSAID not prescribed as
            first-line therapy).
          </li>
          <li id="STOP_PAIN_142">
            Use of daily regular (as distinct from PRN) opioids without concomitant laxative (risk
            of severe constipation).
          </li>
          <li id="STOP_PAIN_143">
            Long-acting opioids without short-acting opioids for break-through moderate or severe
            pain (risk of persistence of severe pain).
          </li>
          <li id="STOP_PAIN_144">
            Topical lidocaine (lignocaine) patch for treatment of chronic osteoarthritis pain (lack
            of evidence of efficacy).
          </li>
          <li id="STOP_PAIN_145">
            Gabapentinoids (e.g., gabapentin, pregabalin) for non-neuropathic pain (lack of evidence
            of efficacy).
          </li>
          <li id="STOP_PAIN_146">
            Paracetamol at doses ≥ 3 g/24 hours in patients with poor nutritional status i.e., BMI
            &lt; 18 or chronic liver disease (risk of hepatotoxicity).
          </li>
        </ol>
      </div>
      <div className="section">
        <h4 id="STOP_ANTIM_147">Section M: Antimuscarinic/Anticholinergic Drug Burden</h4>
        <ol className="criteria-list">
          <li id="STOP_ANTIM_148">
            Concomitant use of two or more drugs with antimuscarinic/anticholinergic properties
            (e.g., bladder antispasmodics, intestinal antispasmodics, tricyclic antidepressants,
            first generation antihistamines, antipsychotics) (risk of increased
            antimuscarinic/anticholinergic toxicity).
          </li>
        </ol>
      </div>

      <div className="page-break">
        <div className="page-divider" />
      </div>

      <div className="title" style={{ textAlign: "center" }}>
        <h1>START</h1>
        <h2 style={{ marginBottom: "0px" }}>Screening Tool to Alert to Right Treatment</h2>
        <p style={{ fontWeight: "bold", marginTop: "0px" }}>
          Unless an elderly patient's clinical status is end-of-life and therefore requiring a more
          palliative focus of pharmacotherapy, the following drug therapies should be considered
          where omitted for no valid clinical reason(s). It is assumed that the prescriber observes
          all the specific contraindications to these drug therapies prior to recommending them to
          older patients.
        </p>
      </div>

      <div className="stickytitle-start">START</div>

      <div className="section">
        <h4 id="START_DIND_151">Section A: Indicated drugs</h4>
        <ol className="criteria-list">
          <li id="START_DIND_152">
            Where a drug is clearly indicated and considered appropriate in the particular clinical
            context and there is no clear contraindication, that drug should be initiated as per
            formulary guidelines for dose and duration.
          </li>
        </ol>
      </div>
      <div className="section">
        <h4 id="START_CVD_153">Section B: Cardiovascular System</h4>
        <ol className="criteria-list">
          <li id="START_CVD_154">
            Antihypertensive therapy where systolic blood pressure &gt; 140 mmHg and /or diastolic
            blood pressure &gt; 90 mmHg, unless established moderate or severe physical frailty in
            whom the threshold for therapy is 150 mmHg systolic pressure and/or 90 mmHg diastolic
            pressure.
          </li>
          <li id="START_CVD_155">
            Statin therapy with a documented history of coronary, cerebral or peripheral vascular
            disease, unless the patient's status is end-of-life or established moderate or severe
            frailty.
          </li>
          <li id="START_CVD_156">
            Angiotensin Converting Enzyme (ACE) inhibitor with coronary artery disease.
          </li>
          <li id="START_CVD_157">Beta-blocker with symptomatic coronary artery disease.</li>
          <li id="START_CVD_158">
            Angiotensin Converting Enzyme (ACE) inhibitor for heart failure with reduced ejection
            fraction.
          </li>
          <li id="START_CVD_159">
            Cardio-selective beta-blocker (bisoprolol, nebivolol, metoprolol or carvedilol) for
            stable heart failure with reduced ejection fraction.
          </li>
          <li id="START_CVD_160">
            Mineralocorticoid receptor antagonist (spironolactone, eplerenone) in heart failure
            without severe renal function impairment i.e., eGFR &gt; 30 ml/min/m2 .
          </li>
          <li id="START_CVD_161">
            SGLT-2 inhibitors (canagliflozin, dapagliflozin, empagliflozin, ertugliflozin) in
            symptomatic heart failure with or without reduced ejection fraction regardless of
            diabetes being present or not.
          </li>
          <li id="START_CVD_162">
            Sacubitril/valsartan in heart failure with reduced ejection fraction causing persistent
            heart failure symptoms despite optimal dose of ACE inhibitor or Angiotensin Receptor
            Blocker (Sacubitril/valsartan to replace ACE inhibitor or Angiotensin Receptor Blocker).
          </li>
          <li id="START_CVD_163">
            Beta-blocker for chronic atrial fibrillation with uncontrolled heart rate.
          </li>
          <li id="START_CVD_164">
            Intravenous iron for symptomatic heart failure with reduced ejection fraction and iron
            deficiency.
          </li>
        </ol>
      </div>
      <div className="section">
        <h4 id="START_COAG_165">Section C: Coagulation System</h4>
        <ol className="criteria-list">
          <li id="START_COAG_166">
            Vitamin K antagonists or direct thrombin inhibitors or factor Xa inhibitors in the
            presence of chronic or paroxysmal atrial fibrillation.
          </li>
          <li id="START_COAG_167">
            Antiplatelet therapy (aspirin or clopidogrel or prasugrel or ticagrelor) with a
            documented history of coronary, cerebral or peripheral vascular disease.
          </li>
        </ol>
      </div>
      <div className="section">
        <h4 id="START_CNS_168">Section D: Central Nervous System</h4>
        <ol className="criteria-list">
          <li id="START_CNS_169">
            L-DOPA or a dopamine agonist in idiopathic Parkinson's disease with functional
            impairment and resultant disability.
          </li>
          <li id="START_CNS_170">Non-TCA antidepressant for major depression.</li>
          <li id="START_CNS_171">
            Acetylcholinesterase inhibitor (donepezil, rivastigmine, galantamine) for mild-moderate
            Alzheimer's dementia.
          </li>
          <li id="START_CNS_172">
            Rivastigmine for Dementia with Lewy Bodies or Parkinson's disease dementia.
          </li>
          <li id="START_CNS_173">
            Selective serotonin reuptake inhibitor (or SNRI or pregabalin if SSRI contraindicated)
            for persistent severe anxiety that affects independent functioning and quality of life.
          </li>
          <li id="START_CNS_174">
            Dopamine agonist (ropinirole or pramipexole or rotigotine) for Restless Legs Syndrome,
            once iron deficiency and severe chronic kidney disease (i.e., eGFR &lt; 30 ml/min/m2)
            have been excluded.
          </li>
          <li id="START_CNS_175">
            Propranolol for essential tremor with functional impairment and resultant disability.
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="START_KDNY_176">Section E: Renal System</h4>
        <ol className="criteria-list">
          <li id="START_KDNY_177">
            One-alpha hydroxycholecalciferol or calcitriol supplementation in severe chronic kidney
            (i.e., eGFR &lt; 30 ml/min/m2) disease with hypocalcaemia (corrected serum calcium &lt;
            2.10 mmol/l) and associated secondary hyperparathyroidism.
          </li>
          <li id="START_KDNY_178">
            Phosphate binder in severe chronic kidney disease (i.e., eGFR &lt; 30 ml/min/m2) if
            serum phosphate concentration persistently &gt;1.76 mmol/l (5.5 mg/dl) despite adherence
            to renal diet.
          </li>
          <li id="START_KDNY_179">
            Erythopoietin analogue in severe chronic kidney disease (i.e., eGFR &lt; 30 ml/min/m2)
            with symptomatic anaemia not attributable to haematinic or iron deficiency to achieve a
            haemoglobin concentration of 10.0 to 12.0 g/dl.
          </li>
          <li id="START_KDNY_180">
            Angiotensin receptor blocker (ARB) or Angiotensin Converting Enzyme Inhibitor (ACE-I) in
            chronic kidney disease with proteinuria i.e., urine albumin excretion &gt;300 mg/24
            hours.
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="START_GI_181">Section F: Gastrointestinal System</h4>
        <ol className="criteria-list">
          <li id="START_GI_182">
            Proton Pump Inhibitor with severe gastro-oesophageal reflux disease or peptic
            oesophageal stricture requiring dilatation.
          </li>
          <li id="START_GI_183">
            Proton pump inhibitor with initiation of low-dose aspirin and previous history of peptic
            ulcer or reflux oesophagitis.
          </li>
          <li id="START_GI_184">
            Proton pump inhibitor with short-term (&lt; 2 weeks) or longer-term (&gt; 2 weeks)
            NSAID.
          </li>
          <li id="START_GI_185">
            Fibre supplements (e.g., bran, ispaghula, methylcellulose, sterculia) for diverticulosis
            with a history of constipation.
          </li>
          <li id="START_GI_186">
            Osmotic laxative (e.g., lactulose, macrogol, sorbitol) for chronic persistent idiopathic
            or secondary benign constipation.
          </li>
          <li id="START_GI_187">
            Probiotics used with antibiotics in patients who are not immunocompromised or severely
            debilitated for the prevention of Clostridioides difficile-associated diarrhoea.
          </li>
          <li id="START_GI_188">
            Helicobacter pylori eradication therapy in HP-associated active peptic ulcer disease.
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="START_RESP_189">Section G: Respiratory System</h4>
        <ol className="criteria-list">
          <li id="START_RESP_190">
            Long-acting muscarinic antagonist (LAMA e.g., tiotropium, aclidinium, umeclidinium,
            glycopyrronium) or long-acting beta 2 agonist (LABA e.g., bambuterol, formoterol,
            indacaterol, olodaterol, salmeterol) for symptomatic COPD of GOLD 1 or 2 severity and
            chronic asthma.
          </li>
          <li id="START_RESP_191">
            Regular i.e. daily inhaled corticosteroid (e.g., beclomethasone, budesonide,
            ciclesonide, fluticasone, mometasone) for moderate-severe asthma or COPD of GOLD 3 or 4
            severity, where FEV1 &lt;50% of predicted value and repeated exacerbations requiring
            treatment with oral corticosteroids.
          </li>
          <li id="START_RESP_192">
            Home continuous oxygen with documented chronic hypoxaemia (i.e., pO2 &lt; 8.0 kPa or 60
            mmHg or SaO2 &lt; 89%).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="START_ORTHO_193">Section H: Musculoskeletal System</h4>
        <ol className="criteria-list">
          <li id="START_ORTHO_194">
            Disease-modifying anti-rheumatic drug (DMARD) with chronic, active and disabling
            rheumatoid arthritis.
          </li>
          <li id="START_ORTHO_195">
            Bisphosphonates and vitamin D and calcium in patients taking long-term systemic
            corticosteroid therapy for prevention of steroid-induced osteoporosis.
          </li>
          <li id="START_ORTHO_196">
            Vitamin D in patients with known osteoporosis and/or previous fragility fracture(s)
            and/or Bone Mineral Density T-scores below -2.5 in one or multiple sites.
          </li>
          <li id="START_ORTHO_197">
            Bone anti-resorptive or anabolic therapy (e.g., bisphosphonate, teriparatide, denosumab)
            in patients with documented osteoporosis (Bone Mineral Density T-scores below -2.5 in
            one or multiple sites) and/or previous history of fragility fracture(s) – where no
            pharmacological or clinical status contraindication exists such as poor one-year life
            expectancy.
          </li>
          <li id="START_ORTHO_198">
            Vitamin D supplement in older people with confirmed 25-hydroxycolecalciferol deficiency
            (&lt; 20 micrograms/L, &lt; 50 nmol/L) who are housebound or experiencing falls or with
            osteopenia (Bone Mineral Density T-score is less than -1.0 but above -2.5 in one or
            multiple sites).
          </li>
          <li id="START_ORTHO_199">
            Anti-resorptive treatment after discontinuation of at least two doses of denosumab
            (rebound increased bone turnover markers, BMD loss, and increased risk of vertebral
            fracture following denosumab discontinuation).
          </li>
          <li id="START_ORTHO_200">
            Anti-resorptive treatment after discontinuation of teriparatide/abaloparatide treatment
            for osteoporosis.
          </li>
          <li id="START_ORTHO_201">
            Xanthine-oxidase inhibitors (e.g. allopurinol, febuxostat) with a history of recurrent
            episodes of gout.
          </li>
          <li id="START_ORTHO_202">Folic acid supplement in patients taking methotrexate.</li>
        </ol>
      </div>

      <div className="section">
        <h4 id="START_GU_203">Section I: Urogenital System</h4>
        <ol className="criteria-list">
          <li id="START_GU_204">
            Selective alpha-1 receptor blocker (e.g., tamsulosin, silodosin) for lower urinary tract
            symptoms related to benign prostatic hyperplasia where prostatectomy is not considered
            necessary or appropriate or safe.
          </li>
          <li id="START_GU_205">
            5-alpha reductase inhibitor (e.g., finasteride, dutasteride) for lower urinary tract
            symptoms related to benign prostatic hyperplasia where prostatectomy is not considered
            necessary or appropriate or safe.
          </li>
          <li id="START_GU_206">
            Topical vaginal oestrogen or vaginal oestrogen pessary for symptomatic atrophic
            vaginitis.
          </li>
          <li id="START_GU_207">
            Topical vaginal oestrogen or vaginal oestrogen pessary in women for recurrent urinary
            tract infections.
          </li>
          <li id="START_GU_208">
            Phosphodiesterase type-5 inhibitors (e.g., avanafil, sildenafil, tadalafil, vardenafil)
            for persistent erectile dysfunction that causes distress.
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="START_ENDO_209">Section J: Endocrine System</h4>
        <ol className="criteria-list">
          <li id="START_ENDO_210">
            ACE inhibitor or Angiotensin Receptor Blocker (if intolerant of ACE inhibitor) in
            diabetes with evidence of renal disease i.e., dipstick proteinuria or microalbuminuria
            (&gt;30 mg/24 hours) unless evidence of severe CKD (eGFR &lt; 30 ml/min/m2).
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="START_PAIN_211">Section K: Analgesics</h4>
        <ol className="criteria-list">
          <li id="START_PAIN_212">
            High-potency opioids in moderate-severe non-arthritis pain, where paracetamol, NSAIDs or
            low-potency opioids are not appropriate to the pain severity or have been ineffective.
          </li>
          <li id="START_PAIN_213">
            Laxatives in patients receiving opioids regularly i.e., other than PRN use.
          </li>
          <li id="START_PAIN_214">
            Topical 5% lidocaine (lignocaine) patch for localized neuropathic pain, e.g.
            post-herpetic neuralgia.
          </li>
        </ol>
      </div>

      <div className="section">
        <h4 id="START_VACC_215">Section L: Vaccines</h4>
        <ol className="criteria-list">
          <li id="START_VACC_216">Seasonal influenza vaccine annually.</li>
          <li id="START_VACC_217">
            Pneumococcal vaccine at least once according to national guidelines.
          </li>
          <li id="START_VACC_218">
            Varicella-zoster vaccine according to national guidelines.
          </li>
          <li id="START_VACC_219">SARS-CoV2 vaccine according to national guidelines</li>
        </ol>
      </div>

      <div className="toolkit-footer">
        <h3>
          CGA Toolkit <span style={{ color: "#cc0000" }}>Plus</span>
        </h3>
      </div>
    </Container>
  );
};

export default SPSTv3;
